import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToPrice = () => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 sm:py-16 lg:py-24 bg-brand-green text-white relative overflow-hidden" data-id="element-44">
      <div className="absolute inset-0 opacity-10" data-id="element-45">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-46"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-48">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-playfair font-bold mb-10 leading-tight" data-id="element-49">
            No es normal vivir <span className="italic" data-id="element-50">inflamada</span> todos
            los días
          </h2>

          <div className="space-y-4 mb-12 text-lg sm:text-xl font-medium text-white/85" data-id="element-51">
            <p data-id="element-52">No es normal sentir dolor después de comer</p>
            <p data-id="element-53">No es normal tener miedo a la comida</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl inline-block mb-10 border border-white/20" data-id="element-54">
            <p className="text-2xl sm:text-3xl font-playfair font-bold text-brand-accent-yellow mb-2" data-id="element-55">
              Pero ya no tenés que seguir así
            </p>
            <p className="text-xl font-inter" data-id="element-56">Empezá hoy</p>
          </div>

          <div data-id="element-57">
            <motion.button onClick={scrollToPrice} className="w-full sm:w-auto bg-brand-accent-orange hover:bg-[#c27622] text-white font-poppins font-bold text-lg sm:text-xl py-5 px-10 rounded-full shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-58">
              QUIERO SENTIRME MEJOR EN 21 DÍAS
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>;
}